import styled from 'styled-components'

import _Icon from '~/components/icon'
import { device, font } from '~/styles/utils'

export const Wrapper = styled.div`
  ${font('base')};
  color: ${({ theme }) => theme.color.text.badge.default};
  background: ${({ theme }) => theme.color.background.badge.default};
  padding: 0 20px 0 15px;
  border-radius: 50px;
  height: 40px;
  display: flex;
  align-items: center;

  @media ${device('notMobile')} {
    padding: 0 23px 0 21px;
  }
`

export const Icon = styled(_Icon)`
  font-size: 16px;
  margin-right: 10px;

  @media ${device('notMobile')} {
    margin-right: 6px;
  }
`
